import styled from "styled-components";
import { isMobile } from "../../../../../utils/common";

export const GraphsContainer = styled.div`
  position: fixed;
  top: 50px;
  left: 50px;
  height: calc(100vh - 50px);
  width: calc(100vw - 400px);
  z-index: 2;
  padding: 10px;
  box-sizing: border-box;
  overflow-y:scroll;
  ${isMobile() &&
  `
     position:static;
     margin-top:50px;
     width:100vw;
     height: fit-content;
  `}
`;
export const GraphsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ErrorCenter = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    height: calc(100vh - 50px);
`;